module.exports = __webpack_public_path__ + "static/media/YB5F12_2.0d2b541c.jpg";